export class TrackUserIpRequestModel {
  sessionTrackingId: string;
  ipAddress: string;
  lattitude: number;
  longitude: number;
  zipCode: string;
  city: string;
  autonomousSystemNumber: string;
}
